<template>
  <span class="service">
    <i-icon :name="data?.icomName" class="service__icon" />
    <span>{{ __(data?.GroupName) }}</span>
    <i-icon v-if="arrow" name="arrow" />
  </span>
</template>

<script>
export default {
  props: {
    data: Object,
    arrow: Boolean,
  },
};
</script>

<style scoped>
.service {
  gap: 15px;
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr auto;

  padding: 10px 15px;

  border-bottom: 1px solid var(--color-border-alt);

  font-size: 16px;
  text-decoration: none;
  color: var(--color-primary);
}

.service__icon {
  width: 37px;
  height: 37px;
}

.service:deep(.svg--arrow) {
  transform: rotate(90deg);

  width: 15px;
  height: 15px;

  color: var(--color-success-hover);
}
</style>
